import React from 'react';
import { DASHBOARD_MODES } from '@sonifi/wb-reporting/constants/wbReportingConstants';

const options = [
  { label: 'Embedded', value: DASHBOARD_MODES.EMBEDDED },
  { label: 'Hardware', value: DASHBOARD_MODES.HARDWARE },
  { label: 'Auto', value: DASHBOARD_MODES.AUTO },
];

const Reporting = ({ register, getValues }) => {
  const dashboardMode = getValues('products.reporting.settings.dashboard_mode');
  return <div className="col-md-offset-1">
    <label className="control-label"><strong>STAYCAST TYPE:</strong></label>
    <br />
    <div className="col-md-3 row">
      <select
        data-testid="dashboard-mode-select"
        className="form-control"
        {...register('products.reporting.settings.dashboard_mode')}
        value={!dashboardMode ? 'auto' : dashboardMode}
      >
        {options.map((option) => (
          <option key={option.label} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
    <br />
    <br />
    <em className="help-block" data-testid="help-text">
      This setting determines which charts display on the reporting page.
    </em>
  </div>;
};

export default Reporting;
